module.exports = __webpack_public_path__ + "img/promotions_nav.055181a0.svg";